<template lang="pug">
  li(:class="{'open active':isOpen}")
    template(v-if="item.children&&item.children.length")
      a(
        href="javascript:;"
        @click="changeOpen")
        span.title.fs-14.f-40 {{item.label}}
          span(:class="['arrow icon-angle-left iconfont', {'open active':isOpen}]")
        span.icon-thumbnail(:class="{'bg-complete':item.isCurrent}")
          i.iconfont(:class="['icon-'+item.icon]")
      ul.sub-menu(:class="{'open':isOpen}")
        NavItem(
          v-for="(child,index) in item.children"
          :key="child.id"
          :item="child")
    template(v-else)
      router-link(:to="item.url", class="lastLink")
        span.title.fs-14.f-34 {{item.label}}
        span.icon-thumbnail(:class="{'bg-complete':item.isCurrent}")
          i.iconfont(:class="['icon-'+item.icon]")
</template>

<script>
export default {
  name: 'NavItem',
  props: {
    item: Object
  },
  data () {
    return {
      isOpen: this.item.isCurrent && this.item.children
    }
  },
  methods: {
    changeOpen: function () {
      this.isOpen = !this.isOpen
    }
  }
}
</script>

<style lang="sass" scoped>
.iconfont
  font-size: 20px
  font-weight: lighter
.f-40
  min-height: 40px
  line-height: 40px
.f-34
  min-height: 34px
  line-height: 34px
.icon-angle-left
  float: right
  transition:all .5s
  -webkit-transition:all .5s
  font-size: 12px
.icon-angle-left.open
  -webkit-transform: rotate(90deg) 
  -ms-transform: rotate(90deg)
  transform: rotate(90deg)
.menu-items
  a
    width: 100%!important
    padding-right: 5px
.sub-menu
  display: none
  list-style: none
  clear: both
  margin: 0 0 10px 0
  background-color: #13161d
  padding: 18px 0 10px 0
  >li
    padding-left: 10px !important
    padding-right: 4px !important
    font-size: 13px
    .icon-thumbnail
      height: 30px
      width: 30px
    >.sub-menu
      font-size: 13px
      .icon-thumbnail
        height: 25px
        width: 25px
.sub-menu.open
  display: block
</style>



// WEBPACK FOOTER //
// NavItem.vue?1024564a